import { logoutBrowserSession } from './api/browserAuthApi';
var LOGOUT_WARNING = 'Kunne ikke logge ut av innloggingstjenesten. Du logges ut av iBok likevel.';
var defaultNavigate = function (href) {
    window.location.href = href;
};
var isPlainLeftClick = function (event) { return event.button === 0
    && !event.altKey
    && !event.ctrlKey
    && !event.metaKey
    && !event.shiftKey; };
var getBrowserAuthLogoutLink = function (event) {
    if (!(event.target instanceof Element)) {
        return null;
    }
    return event.target.closest('a[data-browser-auth-logout]');
};
// eslint-disable-next-line import/prefer-default-export
export var setupBrowserAuthLogoutLinks = function (root, navigate) {
    if (root === void 0) { root = document; }
    if (navigate === void 0) { navigate = defaultNavigate; }
    root.addEventListener('click', function (event) {
        if (!(event instanceof MouseEvent)) {
            return;
        }
        var link = getBrowserAuthLogoutLink(event);
        if (!link || event.defaultPrevented || !isPlainLeftClick(event)) {
            return;
        }
        event.preventDefault();
        var href = link.href;
        logoutBrowserSession()
            .catch(function (error) {
            console.error('Failed to clear browser auth session', error);
            // eslint-disable-next-line no-alert
            window.alert(LOGOUT_WARNING);
        })
            .then(function () {
            navigate(href);
        });
    });
};
